import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { SelectItem } from '@eg/ui';

@Component({
  selector: 'rmb-quick-filters-header',
  templateUrl: './quick-filters-header.component.html',
  styleUrl: './quick-filters-header.component.scss',
  standalone: false,
})
export class QuickFiltersHeaderComponent implements OnChanges {
  @Input() active: boolean;
  @Input() limit: number;
  @Output() resetClicked: EventEmitter<void> = new EventEmitter<void>();
  @Output() saveClicked: EventEmitter<boolean> = new EventEmitter<boolean>();
  filterForm: FormGroup = new FormGroup({
    active: new FormControl<boolean>(true),
    limit: new FormControl<number>(undefined),
  });
  limitOptions: SelectItem[] = [
    { label: '50', value: 50 },
    { label: '75', value: 75 },
    { label: '100', value: 100 },
    { label: '200', value: 200 },
  ];

  ngOnChanges() {
    this.filterForm.patchValue({ active: this.active, limit: this.limit });
  }

  onReset() {
    this.resetClicked.emit();
  }

  addOrUpdateFilter() {
    this.saveClicked.emit(this.filterForm.value);
  }
}
